<div class="atmos-footer-inner">
  <a class="atmos-footer-link" href="https://github.com/Silverfeelin/SkyGame-Planner/" skyTooltip="View on GitHub" target="_blank" rel="noopener">
    <img src="/assets/external/github-mark-white.svg" width="20" height="20" alt="View on GitHub">
  </a>
  <span class="atmos-footer-sep" aria-hidden="true">|</span>
  <span class="atmos-footer-text">
    Images from the
    <a class="atmos-text-link" href="https://sky-children-of-the-light.fandom.com/" target="_blank" rel="noopener">Sky: Children of the Light Wiki</a>
  </span>
  <a class="atmos-footer-privacy atmos-text-link" [routerLink]="'/privacy'">Privacy Policy</a>
</div>
